(() => {
    const selectors = {
        section: ".js-tik-tok-section",
        videoPlayer: ".js-tik-tok-video"
    };

    const videos = document.querySelectorAll(selectors.videoPlayer);

    let currentlyPlaying = null;

    function sendMessage(video, message) {
        video.contentWindow.postMessage({
            'x-tiktok-player': true,
            value: null,
            type: message
        }, '*');
    }

    function handleStateChange(event) {
        if (event.data && event.data['x-tiktok-player']) {
            const { type, value } = event.data;
            const sourceVideo = Array.from(videos).find(video => video.contentWindow === event.source);

            if (type === 'onStateChange' && value === 1) {
                if (currentlyPlaying && currentlyPlaying !== sourceVideo) {
                    sendMessage(currentlyPlaying, 'pause');
                }
                currentlyPlaying = sourceVideo;
            } else if (type === 'onStateChange' && value === 0) {
                if (currentlyPlaying === sourceVideo) {
                    currentlyPlaying = null;
                }
            }
        }
    }

    videos.forEach(video => {
        video.addEventListener('load', function() {
            sendMessage(video, 'onPlayerReady');
        });
    });

    window.addEventListener('message', handleStateChange);
})();
